class MFooter extends HTMLElement{constructor(){super();const e=this.querySelector(".m-footer--accordion"),t=document.querySelector(".m-mobile-sticky-bar");e&&(OpulentTheme.config.mqlMobile&&(this.acc=new OpulentLibs.Accordion(e,{presetContentHeight:!0,onload:!0})),document.addEventListener("matchMobile",(()=>{this.acc=new OpulentLibs.Accordion(e,{presetContentHeight:!0,onload:!0})}))),t&&(document.documentElement.style.setProperty("--mobile-sticky-bar-height",`${t.offsetHeight}px`),document.addEventListener("matchMobile",(()=>{document.documentElement.style.setProperty("--mobile-sticky-bar-height",`${t.offsetHeight}px`)})),document.addEventListener("unmatchMobile",(()=>{document.documentElement.style.setProperty("--mobile-sticky-bar-height",`${t.offsetHeight}px`)})))}}customElements.define("m-footer",MFooter);


function initSimpleCountdown(container) {

    // Use SAME timezone conversion as your previous code (GMT-4 → UTC +4)
    const year = new Date().getUTCFullYear();
    const saleEnd = new Date(Date.UTC(year, 11, 16, 3, 59, 0)); 
    // 11 = December

    const textEl = container.querySelector(".delivery-text");

    function update() {
        const now = new Date();

        if (now >= saleEnd) {
            container.style.display = "none";
            // textEl.textContent = "Guaranteed holiday delivery—offer ended";
            return;
        }

        const diff = saleEnd - now;

        // calculate days & hours remaining
        const totalHours = Math.floor(diff / (1000 * 60 * 60));
        const days = Math.floor(totalHours / 24);
        const hours = totalHours % 24;

        textEl.textContent =
            `Holiday delivery assured — place your international order within ${days} days, ${hours} hours`;
    }

    update();
    setInterval(update, 60 * 1000); // update every minute
}

// Start all countdown instances
document.querySelectorAll(".delivery-countdown").forEach(c => {
    initSimpleCountdown(c);
});
setInterval(function(){
document.querySelectorAll(".delivery-countdown.cart").forEach(c => {
    initSimpleCountdown(c);
});
},1000);